import type { RootState } from "src/store";

export const selectAvatarStage = (state: RootState) => {
  return state.avatarStage;
};
